<template>
    <div class="event-calendar-controls flex w-100 justify-content-between rounded-md overflow-hidden">
        <button
            class="event-calendar-controls__button btn btn-primary grow"
            data-test="event-calendar-controls-list"
            :class="{ 'event-calendar-controls__button--active': !isPreview }"
            @click="showCalendarPreview(false)"
        >
            {{ t('eventCalendar.switch.list') }}
        </button>
        <button
            class="event-calendar-controls__button btn btn-primary grow"
            data-test="event-calendar-controls-preview"
            :class="{ 'event-calendar-controls__button--active': isPreview }"
            @click="showCalendarPreview(true)"
        >
            {{ t('eventCalendar.switch.calendar') }}
        </button>
    </div>
</template>

<script setup lang="ts">
    import { useI18n } from 'vue-i18n';
    import { useVModel } from '@vueuse/core';
    import { useUrlParams } from '~/composables/urlParams';
    import { useAccountStore } from '~/stores/accountStore';
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';

    type EventCalendarProps = {
        isPreview: boolean;
    }

    const PREVIEW_URL_PARAM = 'preview';

    const emit = defineEmits(['update:isPreview']);
    const props = defineProps<EventCalendarProps>();

    const { t } = useI18n();
    const isPreviewLocal = useVModel(props, 'isPreview', emit);

    const { addParam, removeParam } = useUrlParams();
    const { state } = storeToRefs(useAccountStore());
    const buttonColor = computed(() => state.value.buttonColor);
    const buttonTextColor = computed(() => state.value.buttonTextColor);

    const showCalendarPreview = async (showPreview: boolean) => {
        isPreviewLocal.value = showPreview;
        if (showPreview) return await addParam(PREVIEW_URL_PARAM, 'true');
        await removeParam(PREVIEW_URL_PARAM);
    };
</script>

<style scoped lang="scss">
.event-calendar-controls {
  &__button {
    border-radius: 0;
    height: 50px;
    border: unset;
    background-color: v-bind(buttonTextColor);

    &--active {
      background-color: v-bind(buttonColor);
      color: v-bind(buttonTextColor);
    }

    &:hover:not(.active) {
      filter: brightness(90%);
    }
  }
}
</style>
